<template>
    <section>
        <o-pagination :total="100" :per-page="10" disabled />
    </section>
</template>
